import { CheckOut, FinalBill } from './../constants/actionType'

const initialState = {
    creditCheckResponse: null,
    isCreditCheckCleared: false,
    isCreditCheckBannerDisable: false,
    checkExternalCreditCheck: true,
    noSSNCheck: false,
    rtaquesionarrie: null,
    rtaChoice: [],
    isRTArequired: false,
    isDepositRequired: false,
    depositAmount:"",
    isFinalBillRequired: false,
    crvNumber: "",
    finalBill: {
        finalBillOptionVal: 'Yes',
        finalBillAddressCheck: false,
        finalBilldebitCheck: false,
        firstName: "",
        lastName: "",
        cardNumber: "",
        cardType: "",
        securityCode: "",
        expirationDate: {
            Month: "",
            Year: ""
        },
        street: "",
        city: "",
        stateVal: "",
        zip: "",
        response: "",
        finalBillStatus: 'required',
        fNameErr: false,
        lNameErr: false,
        cTypeErr: false,
        cNumErr: false,
        cVVErr: false,
        expMonthErr:false,
        expYearErr:false
    },
    creditFailAttempts: 0,
    depositAttempts: 0,
    finalBillAttempts: 0,
    isDOBFilled :false,
    isSSNFilled:false,
    creditfailed:false,
    creditCheckFailureMessage:null,
    dobACP : '',
    ssnACP : ''
}

function creditCheck(state = initialState, action) {
    switch (action.type) {
        case CheckOut.onUpdateCreditCheck:
            return Object.assign({}, state, {
                creditCheckResponse: action.value
            })
        case CheckOut.onUpdateCreditCheckStatus:
            return Object.assign({}, state, {
                isCreditCheckCleared: action.value
            })
        case CheckOut.isCreditCheckBannerStatus:
            return Object.assign({}, state, {
                isCreditCheckBannerDisable: action.value
            })
        case CheckOut.onUpdateExternalCreditCheck:
            return Object.assign({}, state, {
                checkExternalCreditCheck: !state.checkExternalCreditCheck
            })
        case CheckOut.disableExternalCreditCheck:
            return Object.assign({}, state, {
                checkExternalCreditCheck: false
            })
        case CheckOut.noSSNCheck:
            return Object.assign({}, state, {
                noSSNCheck: !state.noSSNCheck
            })
        case CheckOut.disableSSNCheck:
            return Object.assign({}, state, {
                noSSNCheck: true
            })
        case CheckOut.enableSSNCheck:
            return Object.assign({}, state, {
                noSSNCheck: false
            })
        case CheckOut.updateSSNandDOBStatus:
            return Object.assign({}, state, {
                isSSNFilled: action.value.ssnFilled,
                isDOBFilled: action.value.dobFilled
            })
        case CheckOut.updateRTAQs:
            return Object.assign({}, state, {
                rtaquesionarrie: action.value.rtaquesionarrie,
                rtaChoice: action.value.rtadata
            })
        case CheckOut.updateRTAChoice:
            return Object.assign({}, state, {
                rtaChoice: action.value
            })
        case CheckOut.updateRTAStatus:
            return Object.assign({}, state, {
                isRTArequired: action.value
            })

        case CheckOut.updateDepositInfo:
            return Object.assign({}, state, {
                isDepositRequired: action.value
            })
        case CheckOut.updateDepositAmount:
            return Object.assign({}, state, {
                depositAmount: action.value
            })

        case CheckOut.updateFinalBillStatus:
            return Object.assign({}, state, {
                isFinalBillRequired: action.value
            })

        case CheckOut.updateCRVNunmber:
            return Object.assign({}, state, {
                crvNumber: action.value
            })


        case FinalBill.updateFinalBillOption:
            let payNoCheck = Object.assign({}, state.finalBill, {
                finalBillOptionVal: action.value
            })
            return Object.assign({}, state, {
                finalBill: payNoCheck
            })


        case FinalBill.finalBillStatus:
            let status = Object.assign({}, state.finalBill, {
                finalBillStatus: action.value
            })
            return Object.assign({}, state, {
                finalBill: status
            })

        case FinalBill.finalBilldebitCheck:
            let finalDebitCheck = Object.assign({}, state.finalBill, {
                finalBilldebitCheck: !action.value
            })
            return Object.assign({}, state, {
                finalBill: finalDebitCheck
            })
        case FinalBill.finalBillAddressCheck:
            let finalAddressCheck = Object.assign({}, state.finalBill, {
                finalBillAddressCheck: !action.value
            })
            return Object.assign({}, state, {
                finalBill: finalAddressCheck
            })
        case FinalBill.validateFinalBill:
            let finalBill = Object.assign({}, state.finalBill, {
                firstName: action.value.firstName !== undefined &&
                    action.value.firstName !== state.finalBill.firstName ? action.value.firstName : state.finalBill.firstName,
                lastName: action.value.lastName !== undefined &&
                    action.value.lastName !== state.finalBill.lastName ? action.value.lastName : state.finalBill.lastName,
                cardNumber: action.value.cardNumber !== undefined &&
                    action.value.cardNumber !== state.finalBill.cardNumber ? action.value.cardNumber : state.finalBill.cardNumber,
                cardType: action.value.cardType !== undefined &&
                    action.value.cardType !== state.finalBill.cardType ? action.value.cardType : state.finalBill.cardType,
                expirationDate: {
                    Month: action.value.Month !== undefined &&
                        action.value.Month !== state.finalBill.expirationDate.Month ? action.value.Month : state.finalBill.expirationDate.Month,
                    Year: action.value.Year !== undefined &&
                        action.value.Year !== state.finalBill.expirationDate.Year ? action.value.Year : state.finalBill.expirationDate.Year
                },
                securityCode: action.value.securityCode !== undefined &&
                    action.value.securityCode !== state.finalBill.securityCode ? action.value.securityCode : state.finalBill.securityCode,
                street: action.value.street !== undefined &&
                    action.value.street !== state.finalBill.street ? action.value.street : state.finalBill.street,
                city: action.value.city !== undefined &&
                    action.value.city !== state.finalBill.city ? action.value.city : state.finalBill.city,
                stateVal: action.value.state !== undefined &&
                    action.value.state !== state.finalBill.stateVal ? action.value.state : state.finalBill.stateVal,
                zip: action.value.zip !== undefined &&
                    action.value.zip !== state.finalBill.zip ? action.value.zip : state.finalBill.zip,
            })
            return Object.assign({}, state, {
                finalBill: finalBill,
            })
        case FinalBill.onUpdateFinalBill:
            let getFinalBillresponse = Object.assign({}, state.finalBill, {
                response: action.value
            })
            return Object.assign({}, state, {
                finalBill: getFinalBillresponse
            })
        case CheckOut.updateCreditFailAttempts:
            return Object.assign({}, state, {
                creditFailAttempts: action.value
            })
        case CheckOut.updateFinalBillAttempts:
            return Object.assign({}, state, {
                finalBillAttempts: action.value
            })
        case FinalBill.fNameErr:
            let fNameError = Object.assign({}, state.finalBill, {
                fNameErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: fNameError
            })
        case FinalBill.lNameErr:
            let lNameError = Object.assign({}, state.finalBill, {
                lNameErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: lNameError
            })
        case FinalBill.cTypeErr:
            let cTypeError = Object.assign({}, state.finalBill, {
                cTypeErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: cTypeError
            })
        case FinalBill.cNumErr:
            let cNumError = Object.assign({}, state.finalBill, {
                cNumErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: cNumError
            })
        case FinalBill.cVVErr:
            let cVVError = Object.assign({}, state.finalBill, {
                cVVErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: cVVError
            })
        case FinalBill.expMonthErr:
            let expMonthError = Object.assign({}, state.finalBill, {
                expMonthErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: expMonthError
            })
        case FinalBill.expYearErr:
            let expYearError = Object.assign({}, state.finalBill, {
                expYearErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: expYearError
            })
        case FinalBill.cityErr:
            let cityError = Object.assign({}, state.finalBill, {
                cityErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: cityError
            })
        case FinalBill.streetErr:
            let streetError = Object.assign({}, state.finalBill, {
                streetErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: streetError
            })
        case FinalBill.stateValErr:
            let stateValError = Object.assign({}, state.finalBill, {
                stateValErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: stateValError
            })
        case FinalBill.zipErr:
            let zipError = Object.assign({}, state.finalBill, {
                zipErr: action.value
            })
            return Object.assign({}, state, {
                finalBill: zipError
            })
        case 'CREDIT_FAILURE':
            return Object.assign({}, state, {
                creditfailed: action.value
            })        
        case 'UPDATE_CREDITCHECK_MESSAGE':
                return Object.assign({}, state, {
                    creditCheckFailureMessage: action.value
                })  
        case 'ACP_CREDIT_CHECK_UPDATE':
            return Object.assign({}, state, {
                dobACP : action.value.dob,
                ssnACP : action.value.ssn4,
                isDOBFilled : action.value.dob ? true : state.isDOBFilled
            })
        case 'UPDATE_DOB_CREDIT_CHECK':
            return Object.assign({}, state, {
                dobACP : action.value,
            })
        case 'EMPTY_CREDITCHECK':
            return initialState
        default:
            return state
    }
}

export default creditCheck